<template>
	<div
		class="absolute -top-9.5 right-0 left-0 flex h-7.5 items-center justify-center"
	>
		<LogoSimpleIcon
			class="h-4.5"
			v-hover="{ active: 'scale-90' }"
			@click="openReportModal"
		/>
		<ReportModal v-model="report" />
	</div>
</template>
<script setup lang="ts">
import LogoSimpleIcon from '@/assets/icons/logo-simple.svg'
import ReportModal from './modals/ReportModal.vue'
import { ref } from 'vue'

const report = ref(false)

const openReportModal = () => {
	report.value = true
}
</script>
